import { css, html, htmlArray } from "../helpers/webComponents";
import { KeyPadService } from "../services/KeyPadService";
import { CanvasComponent } from "./CanvasComponent";

/** CSS affecting the {@link CanvasComponent} */
const styles: string = css`
    :host {
        z-index: 3;
        display: flex;
        justify-content: center;
    }
    .padlock {
        margin: 20px;
        padding: 40px;
        background-color: #9e9e9e;
        color: black;
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: center;
        border-radius: 2px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        width: 200px;
        position: relative;
    }

    .cross {
        position: absolute;
        right: 5px;
        top: 5px;
    }
    
    .cross {
        cursor: pointer;
    }

    .padlock-code {
        background-color: #008000;
        color: black;
        padding: 8px 0px;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        border: 3px solid black;
        min-width: 80px;
        font-family: "Onesize";
        width: 100%;
        min-height: 20px;
    }

    .padlock-buttons {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 4px;
        /* padding: 5px; */
    }

    .padlock-button {
        background-color: #666;
        border: 3px solid black;
        color: white;
        font-size: 16px;
        height: 50px;
        width: 50px;
        font-family: "Onesize";
        box-shadow: 4px 4px 0px #333;
        transition: none;
        cursor: pointer;
    }

    .padlock-button:hover {
        background-color: #888;
        box-shadow: 2px 2px 0px #222;
    }

    .padlock-button:active {
        background-color: #555;
        box-shadow: inset 2px 2px 0px #222;
    }

    .padlock-button:nth-last-child(2) { /* Clear Button */
        background-color: #777;
    }

    .padlock-button:nth-last-child(1) { /* OK Button */
        background-color: #777;
    }
`;

export class KeypadComponent extends HTMLElement {
    private codeElement: HTMLElement = this.renderKeypadCode();

    private _type: string | undefined;

    /**
     * This function is called whenever the component is created.
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this._type = this.attributes.getNamedItem("type")?.value;

        this.render();
    }

    /**
     * This function renders the html in the shadowroot.
     */
    public render(): void {
        this.shadowRoot?.append(...this.renderHTML());
    }

    /**
     * This function returns the html element.
     * @returns HTMLElement
     */
    public renderHTML(): HTMLElement[] {
        return htmlArray`
            <style>
                ${styles}
            </style>
            ${this.renderKeypad()}
        `;
    }

    public renderKeypad(): HTMLElement {
        return html`
            <div class="padlock">
                ${this.renderCloseButton()}
                ${this.codeElement}
                <div class="padlock-buttons">
                    ${this.renderButton("1")}
                    ${this.renderButton("2")}
                    ${this.renderButton("3")}
                    ${this.renderButton("4")}
                    ${this.renderButton("5")}
                    ${this.renderButton("6")}
                    ${this.renderButton("7")}
                    ${this.renderButton("8")}
                    ${this.renderButton("9")}
                    ${this.renderButton("0")}
                    ${this.renderButton("C")}
                    ${this.renderButton("OK")}
                </div>
            </div>
        `;
    }

    public renderKeypadCode(): HTMLElement {
        return html`
            <div class="padlock-code"></div>
        `;
    }

    public renderButton(value: string): HTMLElement {
        const button: HTMLElement = html`<button class="padlock-button">${value}</button>`;
        switch (value) {
            case "C":
                button.addEventListener("click", () => this.removeCode());
                break;
            case "OK":
                button.addEventListener("click", () => this.checkCode());
                break;
            default:
                button.addEventListener("click", () => this.addNumberToCode(value));
                break;
        }
        return button;
    }

    public renderCloseButton(): HTMLElement {
        const cross: HTMLElement = html`
            <div class="cross">
                X
            </div>
        `;
        cross.addEventListener("click", () => {
            CanvasComponent.closeFromSubcomponent();
        });
        return cross;
    }

    public addNumberToCode(value: string): void {
        // check if there are less than 4 numbers
        if (this.codeElement.innerHTML.length < 4) {
            this.codeElement.innerHTML += value;
        }
    }

    public removeCode(): void {
        this.codeElement.innerHTML = "";
    }

    public async checkCode(): Promise<void> {
        const keyPadService: KeyPadService = new KeyPadService();
        if (!this._type) return;
        if (await keyPadService.checkCode(this._type, this.codeElement.innerHTML)) {
            this.codeElement.innerHTML = "Correct!";
            setTimeout(() => {
                CanvasComponent.closeFromSubcomponent();
            },
            2000);
        }
        else {
            this.codeElement.innerHTML = "Incorrect!";
            setTimeout(() => {
                this.codeElement.innerHTML = "";
            },
            2000);
        }
    }
}
